import {Component, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {Report, ReportCreation, ReportSection, ReportSectionEnum} from '../../../models/measure/report';
import {MeasureSearchCriteria} from '../../../models/measure/measure-search-criteria';
import {MeasureService} from '../../services/measure/measure.service';
import {UserService} from '../../services/user.service';
import {CampaignService} from '../../services/campaign/campaign.service';
import {InfluencerGroupsService} from '../influencer-groups/influencer-groups.service';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {CommonConstant, BestPerformingInfluencerSortBy} from '../../app.constants';
import {TranslateService} from '@ngx-translate/core';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';
import {Subscription} from 'rxjs/Subscription';
import * as Sentry from '@sentry/browser';
import {MeasureModulesSelectionComponent} from './measure-modules-selection/measure-modules-selection.component';
import {Project} from '../../../models/project/project';
import {ObjectUtils} from '../../utils/object.utils';
import {MeasureBreadcumbComponent} from './measure-breadcumb/measure-breadcumb.component';
import {DateUtils} from '../../utils/date.utils';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {PdfViewerService} from '../pdf-viewer/pdf-viewer.service';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';
import {ActivePage} from '../../../models/event-tracker';
import {Observable} from 'rxjs/Observable';
import {DateRange} from '../../../models/date-range';
import {MeasureReportTimeline} from './measure-setting/measure-setting.component';
import {NgbDateUtils} from '../../utils/ngb-date.utils';
import {MeasureModuleDropdownComponent} from './measure-module-dropdown/measure-module-dropdown.component';
import {MeasurePdfExportComponent} from './measure-pdf-export/measure-pdf-export.component';

@Component({
  selector: 'achoo-measure',
  templateUrl: './measure.component.html',
  styleUrls: ['./measure.component.scss']
})
export class MeasureComponent extends AbstractAchooComponent implements OnInit, OnDestroy {

  @ViewChild('WarningMeasureDialog')
  warningMeasureDialog: AchooPopupComponent;
  @ViewChild('NotificationMeasure')
  notificationMeasure: AchooPopupComponent;
  @ViewChild('NotificationCreateOrUpdateReport')
  notificationCreateOrUpdateReport: AchooPopupComponent;
  @ViewChildren(MeasureModulesSelectionComponent)
  selectedModuleComponents: QueryList<MeasureModulesSelectionComponent>;
  @ViewChild('measureBreadcumb')
  measureBreadcumb: MeasureBreadcumbComponent;
  @ViewChild('WarningCancelEditReportDialog')
  warningCancelReportDialog: AchooPopupComponent;
  @ViewChild('AlertPdfDownloadPending')
  alertPdfDownloadPending: AchooPopupComponent;
  @ViewChild('WarningWhenSwitchingAccountInEditMode')
  warningWhenSwitchingAccountInEditMode: AchooPopupComponent;
  @ViewChild('NotificationWarningEditDefaultReport')
  notificationWarningEditDefaultReport: AchooPopupComponent;
  @ViewChild('moduleDropDown')
  moduleDropDown: MeasureModuleDropdownComponent;
  @ViewChild('MeasureExporting')
  measureExporting: MeasurePdfExportComponent;

  public reportData = {};
  public selectedReport: Report;
  public reportList: Report[] = [];
  public warningMessage: string;
  public notificationContent: string;
  public statusBottomBar;
  public selectedProject: Project = new Project();
  // the flag is used to know whether the user is creating or editing a report or in read only mode
  public editingReportMode = false;
  // this flag use to know when the filter is open or close. Default is open
  public isFilterShow = true;
  // flag to indicate whether show or hide module exporting
  public showExportingModule = false;

  /**
   * Define a list of subcription for async loading report data
   */
  public roiReportSubscription: Subscription;
  public performanceTimelineReportSubscription: Subscription;
  public performanceGlobalKPIReportSubscription: Subscription;
  public marketDrillDownReportSubscription: Subscription;
  public mentionTimelineReportSubscription: Subscription;
  public exposureKPIReportSubscription: Subscription;
  public topExposuresReportSubscription: Subscription;
  public bestPerformanceExposuresReportSubscription: Subscription;
  public benchmarkPerformanceReportSubscription: Subscription;
  public interactionReportSubscription: Subscription;
  public topicDrillDownReportSubscription: Subscription;
  public segmentIndustryReportSubscription: Subscription;
  public segmentInfluencerOverviewSubscription: Subscription;
  public platformReachSubscription: Subscription;
  public bestPerformingReportSubscription: Subscription;
  public insightOpportunityReportSubscription: Subscription;
  public oonaReportSubscription: Subscription;
  public bestPerformingReportForEngagementSubscription: Subscription;
  public bestPerformingReportDataForEngagement;
  public bestPerformingReportDataForReach;
  public selectedBestPerformingInfluencerOrder: string;

  /**
   * reference data for filter box
   */
  public campaignList: any = [];
  public listProjectOfAdvertiser: any[] = [];
  public influencerGroups: any = [];
  public platformList: any = [];
  public countryList: any = [];
  public reportCriteria: MeasureSearchCriteria = new MeasureSearchCriteria();
  public initializeCriteria: any;

  /**
   * list all of supported module
   */
  public moduleList: any[] = [];
  /**
   * selected module Ids which are generated in report content
   */
  public selectedModuleIds: number[] = [];

  /**
   * selected module Ids which are generated in report content
   */
  public listModuleForPdf: number[] = [];
  public roiIndexMapping: Map<number, number> = new Map();
  public oonaIndexMapping: Map<number, number> = new Map();
  public interactionIndexMapping: Map<number, number> = new Map();

  /**
   * list module Ids which are selecting in list supported modules
   */
  public selectingModuleItems: any[] = [];

  public exportPdfSubcription: Subscription;

  // show mwssage when select project without mentions
  public selectedProjectWithoutMention = false;

  // number of post included into pdf report
  protected numberOfPostInOnnaPdf = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
  protected numberOfPostInRoiPdf = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
  protected numberOfPostInInteractionPdf = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
  /**
   * Report settings
   */
  public activeBenchmarkPerformance: number;
  public activeChannelOpportunity: number;
  public removedTopicInsights: string[];

  private moduleArr: number[] = [];

  public notificationCreateOrUpdateReportMessage: string;

  constructor(private measureService: MeasureService,
              private campaignService: CampaignService,
              private influencerGroupService: InfluencerGroupsService,
              private referenceDataService: ReferenceDataService,
              private translate: TranslateService,
              protected userService: UserService,
              private modalService: ModalService,
              private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              private pdfViewerService: PdfViewerService,
              private pdfService: PdfExportService,
              private eventTracker: EventTrackerService) {
    super(userService);
    this.reportCriteria.company_id = this.userService.getCompanyId();
    this.reportCriteria.period = this.getDefaultDateRange();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const formatedParams = {};
      Object.keys(params).forEach((key) => {
        const rawValue = params[key];
        if (isNaN(rawValue)) {
          formatedParams[key] = rawValue;
        } else {
          formatedParams[key] = Number(rawValue);
        }
      });

      this.initializeCriteria = formatedParams;
      this.initializeFilterCriteria();
    });

    super.ngOnInit();

    // load list supported platforms and countries
    const referenceData = this.referenceDataService.referenceData;
    this.countryList = referenceData.countries.map((country) => ({
        id: country.id,
        name: country.name
      })
    );
    this.platformList = referenceData.platforms;

    this.measureService.loadListModules().subscribe((res) => {
      this.moduleList = res;
    });
    this.selectedBestPerformingInfluencerOrder = BestPerformingInfluencerSortBy.REACH;
    this.reportCriteria.orderBy = BestPerformingInfluencerSortBy.REACH;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    // unscribe all active subcriptions
    this.cancelPendingRequest();
  }

  // The callback when switching account
  companyChangeCallback(companyId) {
    if (this.editingReportMode) {
      this.modalService.openInCenter(this.warningWhenSwitchingAccountInEditMode);
      return;
    }
    // cancel all pending request
    this.cancelPendingRequest();
    // clear the previous data
    this.resetReportData();
    // reset selecting module item list
    this.selectingModuleItems = [];

    // update activeAccount param
    this.initializeCriteria.activeAccount = companyId;
    this.reportCriteria.company_id = companyId;

    // load list existing reports
    this.loadListReports(companyId, this.initializeCriteria.reportId, true);

    // load list existing project of advertiser
    this.reloadProjectAndCampaign(companyId);
  }

  private reloadProjectAndCampaign(companyId) {
    Observable.forkJoin(
      this.userService.getAllProjectOfAdvertiser(),
      this.campaignService.getCampaignFullListForCompany(companyId, false),
      this.campaignService.getCampaignFullListForCompany(companyId, true),
      this.influencerGroupService.getInfluencerGroupShortList(companyId)
    ).subscribe((res) => {
      // update list campaign and project by current companyId
      if (res[0]) {
        this.updateProjectSelection(res[0].data);
      }
      if (res[1] && Array.isArray(res[1].campaigns)) {
        this.campaignList = res[1].campaigns;
      }
      if (res[2] && Array.isArray(res[2].campaigns)) {
        this.campaignList = this.campaignList.concat(res[2].campaigns);
      }
      this.influencerGroups = res[3] ? res[3].map(group => ({
        id: group.id,
        name: group.name
      })) : [];
      // not allow to render measure for free user
      if (this.userService.isFreeUser() && !this.userService.isAdmin) {
        return;
      }
      // update current project and campaign criteria
      // using the resquest params if existing and belonging to current company
      // default using the first project
      let initializedProjectId = this.listProjectOfAdvertiser.length > 1 ? this.listProjectOfAdvertiser[1].id : undefined;
      let initializedCampaignId = this.campaignList.length > 0 ? this.campaignList[0].id : undefined;
      if (this.haveValidProjectParam(this.initializeCriteria)) {
        initializedProjectId = this.initializeCriteria.project_id;
        this.reportCriteria.project_id = initializedProjectId;
        this.reportCriteria.campaign_id = null;
        this.reportCriteria.influencerGroup = null;
        // reset unused params
        this.initializeCriteria.campaign_id = null;
        this.initializeCriteria.influencerGroup = null;
      } else if (this.haveValidCampaignParam(this.initializeCriteria)) {
        initializedCampaignId = this.initializeCriteria.campaign_id;
        this.reportCriteria.project_id = null;
        this.reportCriteria.campaign_id = initializedCampaignId;
        this.reportCriteria.influencerGroup = null;
        // reset unused params
        this.initializeCriteria.project_id = null;
        this.initializeCriteria.influencerGroup = null;
      } else if (this.haveValidGroupParam(this.initializeCriteria)) {
        this.reportCriteria.project_id = null;
        this.reportCriteria.campaign_id = null;
        this.reportCriteria.influencerGroup = this.initializeCriteria.influencerGroup;
        // reset unused params
        this.initializeCriteria.project_id = null;
        this.initializeCriteria.campaign_id = null;
      } else {
        this.reportCriteria.project_id = initializedProjectId;
        this.reportCriteria.campaign_id = null;
        this.reportCriteria.influencerGroup = null;
        // reset unused params
        this.initializeCriteria.project_id = null;
        this.initializeCriteria.campaign_id = null;
        this.initializeCriteria.influencerGroup = null;
      }
      // track event open report to Segment
      this.viewReportTracker(this.selectedReport, this.listProjectOfAdvertiser.find(p => p.id === initializedProjectId));
      // generate the default report by the default project id
      this.generateReportByCriteria(this.reportCriteria);
    });
  }

  /**
   * validate the campaignId in request parameters is valid and belonged to current company
   * @param initializeCriteria
   * @returns {boolean}
   */
  private haveValidCampaignParam(initializeCriteria) {
    if (!initializeCriteria || !initializeCriteria.campaign_id || (initializeCriteria.campaign_id <= 0)) {
      return false;
    }
    return this.campaignList.filter(p => p.id === initializeCriteria.campaign_id).length > 0;
  }

  /**
   * validate the influencerGroup in request parameters is valid and belonged to current company
   * @param initializeCriteria
   * @returns {boolean}
   */
  private haveValidGroupParam(initializeCriteria) {
    if (!initializeCriteria || !initializeCriteria.influencerGroup || (initializeCriteria.influencerGroup <= 0)) {
      return false;
    }
    return this.influencerGroups.filter(p => p.id === initializeCriteria.influencerGroup).length > 0;
  }

  /**
   * validate the projectId in request parameters is valid and belonged to current company
   * @param initializeCriteria
   * @returns {boolean}
   */
  private haveValidProjectParam(initializeCriteria) {
    if (!initializeCriteria || !initializeCriteria.project_id || (initializeCriteria.project_id <= 0)) {
      return false;
    }
    return this.listProjectOfAdvertiser.filter(p => p.id === initializeCriteria.project_id).length > 0;
  }

  public loadListProject() {
    this.userService.getAllProjectOfAdvertiser().subscribe((res: any) => {
      this.updateProjectSelection(res.data);
      // not allow to load measure by project for free user
      if (!this.userService.isFreeUser() || this.userService.isAdmin) {
        // track event open report to Segment
        this.viewReportTracker(this.selectedReport, this.listProjectOfAdvertiser[1]);
        // generate the default report by the default project id
        this.generateReportByCriteria(this.reportCriteria);
      }
    });
  }

  private updateProjectSelection(listProject) {
    this.listProjectOfAdvertiser = [{
      id: 0,
      name: this.translate.instant('measure.create_new_project')
    }];

    if (Array.isArray(listProject)) {
      this.listProjectOfAdvertiser.push(...listProject);
    }
  }

  public loadListReports(companyId: number, selectedReportId?: number, reloadReportContent?: boolean) {
    // load list existing reports
    this.measureService.getListMeasureReport(companyId).subscribe((reports) => {
      this.reportList = this.buildReportList(reports, selectedReportId, reloadReportContent);
    });
  }

  public createNewReport(e) {
    // enable flag to set user in editable mode
    this.editingReportMode = true;
    // set default value of new report
    const newReport: Report = new Report();
    newReport.sectionList = [];

    // set new report as selected report
    this.onSelectExistingReport(newReport);
    // update position of arrow
    this.measureBreadcumb.updateArrowPosition('', CommonConstant.MAX_LENGTH_REPORT_NAME_FIELD);
    // set focus on edit field
    this.measureBreadcumb.reportNameInputField.setFocus();
    // update default selected module on dropdown
    this.moduleDropDown.initializeSelectedModuleForNewReport();
  }

  public editReport(e) {
    this.editingReportMode = true;
    // set focus on edit field
    this.measureBreadcumb.reportNameInputField.setFocus();
  }

  public showWarningBeforeCancelEditReport() {
    this.modalService.openInCenter(this.warningCancelReportDialog);
  }

  public cancelEditReport() {
    // in case edit, reload the previous report after cancelling
    // in case create new, reload list report
    if (this.selectedReport.id > 0) {
      this.loadListReports(this.userService.getCompanyId(), this.selectedReport.id, true);
    } else {
      this.loadListReports(this.userService.getCompanyId(), undefined, true);
    }
    this.exitWithoutChanging();
  }

  public createOrUpdateReport(report, showNotification = true) {
    // stop processing if no selected report
    if (!report) {
      return;
    }

    // not allow to update default report
    if (report.is_default_report) {
      this.modalService.open(this.notificationWarningEditDefaultReport, undefined, true);
      return;
    }

    // disable edit report
    this.editingReportMode = false;

    // Create new report object
    const saveReport = new ReportCreation();
    saveReport.id = report.id;
    saveReport.reportName = report.name;
    saveReport.companyId = this.userService.getCompanyId();

    // Add available sections to new report
    this.selectedModuleIds.forEach((moduleId, index) => {
      const module = report.sectionList.find(m => m.id === moduleId);
      if (module) {
        module.section_id = module.id;
        module.position = index;
        saveReport.sections.push(module);
      }
    });

    // Call create report API with new report params
    this.measureService.createOrUpdateReport(saveReport).subscribe(
      // Success
      (res) => {
        // reset selected group to default after saving report
        this.moduleDropDown.selectedGroupId = CommonConstant.ALL_MODULES_ID;
        if (showNotification) {
          this.notificationCreateOrUpdateReportMessage = this.getNotificationMessageForCreation(report);
          // show notification
          this.modalService.open(this.notificationCreateOrUpdateReport, undefined, true);
        }
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, undefined, {
          action: saveReport.id > 0 ? UserActionType.UPDATE : UserActionType.CREATE,
          source: ActionSource.PAGE,
          ...saveReport
        }, {
          id: res.data.id,
          name: res.data.report_name
        }, {
          type: ActivePages.MEASURE,
          name: res.data.report_name,
          id: res.data.id
        });
        // load list report
        this.loadListReports(this.userService.getCompanyId(), res.data.id);
      },
      // Error
      (error) => {
        this.editingReportMode = true;
        this.warningMessage = error.error.message;
        this.modalService.open(this.warningMeasureDialog, undefined, true);
      }
    );
  }

  /**
   * get notification message after saving report
   * @param report
   * @returns {string | any}
   */
  private getNotificationMessageForCreation(report) {
    if (!report) {
      // return empty string if no selected report
      return '';
    } else if (report.id > 0) {
      return this.translate.instant('measure.update_report_notification', {reportName: report.name});
    } else {
      return this.translate.instant('measure.create_new_report_notification');
    }
  }

  onSelectExistingReport(selectedReport) {
    this.selectedReport = selectedReport;
    this.selectedModuleIds = this.selectedReport.sectionList.map(section => section.id);
    this.generateReportByCriteria(this.reportCriteria);

    this.trackMeasureView(selectedReport, this.reportCriteria);
  }

  private getTrackerReportCriteriaTarget(reportFilterCriteria: MeasureSearchCriteria) {
    let targetId, targetName, targetType;
    if (reportFilterCriteria.project_id) {
      const project = this.listProjectOfAdvertiser.find(p => p.id === reportFilterCriteria.project_id);
      if (project) {
        targetId = project.id;
        targetName = project.name;
        targetType = 'Project';
      }
    } else if (reportFilterCriteria.influencerGroup) {
      const inflGroup = this.influencerGroups.find(infl => infl.id === reportFilterCriteria.influencerGroup);
      if (inflGroup) {
        targetId = inflGroup.id;
        targetName = inflGroup.name;
        targetType = 'Influencer Group';
      }
    } else if (reportFilterCriteria.campaign_id) {
      const campaign = this.campaignList.find(camp => camp.id === reportFilterCriteria.campaign_id);
      if (campaign) {
        targetId = campaign.id;
        targetName = campaign.name;
        targetType = 'Campaign';
      }
    }
    return {
      targetId: targetId,
      targetName: targetName,
      targetType: targetType
    };
  }

  private trackMeasureView(selectReport: Report, reportFilterCriteria: MeasureSearchCriteria) {
    let targetId, targetName, targetType;

    const target = this.getTrackerReportCriteriaTarget(reportFilterCriteria);
    targetId = target.targetId,
    targetName = target.targetName,
    targetType = target.targetType,

    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.MEASURE, {
      id: targetId,
      name: targetName,
      type: targetType
    }, undefined, {
      id: selectReport.id,
      name: selectReport.name
    }, {
      type: ActivePages.MEASURE,
      name: selectReport.name,
      id: selectReport.id
    });
  }

  onCreateOrEditProject(project) {
    this.selectedProject = ObjectUtils.deepClone(project);
    this.statusBottomBar = 'active';
  }

  onChangeActiveModuleList(evt) {
    const currentSelectingModuleIds = this.selectingModuleItems.map(sm => sm.id);
    const newActiveModules = evt.filter(e => currentSelectingModuleIds.indexOf(e.id) < 0);
    this.selectedModuleIds = evt.map(m => m.id);
    this.updateModuleList(newActiveModules);
    this.selectingModuleItems = evt;
  }

  /**
   * execute the latest update of module list. Call when dropdown is closed
   * @param e
   */
  updateModuleList(selectingModuleItems) {
    if (selectingModuleItems.length === 0) {
      return;
    }
    // not allow to edit a default report
    if (this.selectedReport && this.selectedReport.is_default_report) {
      this.modalService.open(this.notificationWarningEditDefaultReport, undefined, true);
      return;
    }
    // update report content
    selectingModuleItems.forEach((module) => {
      // add new module if this module is not selected
      if (!this.isExistingModule(this.selectedReport, module)) {
        // create a new report section and add it to selected report
        const newSection: ReportSection = new ReportSection();
        newSection.id = module.id;
        newSection.section_id = module.id;
        newSection.section_template = module.template;
        newSection.position = this.findTheMaximunPositionOfModule(this.selectedReport);
        this.selectedReport.sectionList.push(newSection);

        // generate report content for new section
        const currentCriteria = this.reportCriteria;
        if (this.isValidCriteriaToGenerateReport(currentCriteria)) {
          // fulfill the current criteria before peforming async load
          const fulfillCurrentCriteria = this.fulfillCriteria(currentCriteria);
          // load data and generate report content of new module
          this.generateReportBySection(module.id, fulfillCurrentCriteria);
        }
      }
    });

    // track event by segment
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, {
      type: TargetType.MODULES
    }, {
      action: UserActionType.SELECTION,
      source: ActionSource.PAGE,
      selectedModules: selectingModuleItems.map(item => ({
        id: item.id,
        name: item.name
      }))
    }, {
      id: this.selectedReport.id,
      name: this.selectedReport.name
    }, {
      type: ActivePages.MEASURE,
      name: this.selectedReport.name,
      id: this.selectedReport.id
    });
  }

  get activeReport() {
    return this.selectedReport || new Report();
  }

  getReportDataById(section: ReportSectionEnum) {
    const sectionData = Object.getOwnPropertyDescriptor(this.reportData, section);

    return sectionData ? sectionData.value.data : undefined;
  }

  getReportTitleById(section: ReportSectionEnum) {
    const sectionTitle = Object.getOwnPropertyDescriptor(this.reportData, section);
    return sectionTitle ? sectionTitle.value.title : undefined;
  }

  isActiveBottomBar() {
    return this.statusBottomBar === 'active';
  }

  isInactiveBottomBar() {
    return !this.statusBottomBar || this.statusBottomBar === 'inactive';
  }

  onChangeReportPeriod(selectedPeriod) {
    if (!selectedPeriod) {
      return;
    }
    // update criteria
    this.reportCriteria.period = DateRange.buildDateRangeWithBorder(selectedPeriod.fromDate, selectedPeriod.toDate);
    // update report content
    this.generateReportByCriteria(this.reportCriteria);
    // track event by segment
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.MEASURE, {
      id: selectedPeriod.name,
      name: selectedPeriod.name,
      type: TargetType.DATE_RANGE
    }, {
      action: UserActionType.TOGGLE,
      source: ActionSource.PAGE,
    }, {
      id: this.selectedReport.id,
      name: this.selectedReport.name
    }, {
      type: ActivePages.MEASURE,
      name: this.selectedReport.name,
      id: this.selectedReport.id
    });
  }

  deleteExistingReport(selectedReport) {
    this.measureService.deleteReport(selectedReport.id, this.userService.getCompanyId()).subscribe((res) => {
      // reload list report
      this.loadListReports(this.userService.getCompanyId());
      // track event by segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, {
        id: selectedReport.id,
        name: selectedReport.name,
        type: TargetType.REPORT
      }, {
        action: UserActionType.DELETE,
        source: ActionSource.PAGE,
      }, {
        id: this.selectedReport.id,
        name: this.selectedReport.name
      }, {
        type: ActivePages.MEASURE,
        name: this.selectedReport.name,
        id: this.selectedReport.id
      });
    });
  }

  initializeFilterCriteria() {
    this.preCheckInitializeCriteria();
    this.reportCriteria = new MeasureSearchCriteria();
    this.reportCriteria = Object.assign({}, this.reportCriteria, this.initializeCriteria);
    if (this.initializeCriteria.from && this.initializeCriteria.to) {
      const selectedDateRange = new DateRange();
      selectedDateRange.startDate = this.initializeCriteria.from;
      selectedDateRange.endDate = this.initializeCriteria.to;
      this.reportCriteria.period = selectedDateRange;
    } else {
      this.reportCriteria.period = this.getDefaultDateRange();
    }
    if (this.initializeCriteria.roi_posts) {
      this.numberOfPostInRoiPdf = this.initializeCriteria.roi_posts;
    }
    if (this.initializeCriteria.interaction_posts) {
      this.numberOfPostInInteractionPdf = this.initializeCriteria.interaction_posts;
    }
    if (this.initializeCriteria.benchmark_posts) {
      this.numberOfPostInOnnaPdf = this.initializeCriteria.benchmark_posts;
    }
    if (this.initializeCriteria.active_bp) {
      this.activeBenchmarkPerformance = Number(this.initializeCriteria.active_bp);
    }
    if (this.initializeCriteria.active_co) {
      this.activeChannelOpportunity = Number(this.initializeCriteria.active_co);
    }
    if (this.initializeCriteria.removed_ti) {
      this.removedTopicInsights = this.initializeCriteria.removed_ti.split(',');
    } else {
      this.removedTopicInsights = [];
    }
  }

  private preCheckInitializeCriteria() {
    if (!this.initializeCriteria.from || !this.initializeCriteria.to) {
      return;
    }
    const initalizedFromDate = new Date(this.initializeCriteria.from);
    const initalizedToDate = new Date(this.initializeCriteria.to);
    const today = DateUtils.now();
    if (!DateUtils.isValidDate(initalizedFromDate) || !DateUtils.isValidDate(initalizedToDate) ||
      DateUtils.after(initalizedFromDate, today) || DateUtils.after(initalizedFromDate, initalizedToDate)) {
      delete this.initializeCriteria.from;
      delete  this.initializeCriteria.to;
    } else if (DateUtils.after(initalizedToDate, today)) {
      this.initializeCriteria.to = DateUtils.convertDateToString(today.getTime(), 'yyyy-MM-dd');
    }
  }

  onClearFilter() {
    const dateRange = this.reportCriteria.period;
    this.reportCriteria = new MeasureSearchCriteria();
    this.reportCriteria.period = dateRange;
  }

  onChangeCriteria(criteria) {
    // update local criteria
    this.reportCriteria = criteria;
    // re-generate report
    this.generateReportByCriteria(criteria);
  }

  updateSupportLink(criteria) {
    // not update url while exporting pdf
    if (this.pdfService.exportingPdf) {
      return;
    }
    const cloneCriteria = Object.assign({}, criteria,
      {
        activeAccount: this.userService.getCompanyId(),
        reportId: this.selectedReport && this.selectedReport.id,
        period: null,
        date: null,
        from: criteria.period ? criteria.period.startDate : null,
        to: criteria.period ? criteria.period.endDate : null,
        benchmark_posts: this.numberOfPostInOnnaPdf,
        interaction_posts: this.numberOfPostInInteractionPdf,
        roi_posts: this.numberOfPostInRoiPdf,
        active_bp: this.activeBenchmarkPerformance,
        active_co: this.activeChannelOpportunity,
        removed_ti: this.removedTopicInsights ? this.removedTopicInsights.join(',') : null
      });
    // keep track report Id
    this.initializeCriteria.reportId = cloneCriteria.reportId;
    const url = this.router
      .createUrlTree(['/measure'], { queryParams: cloneCriteria })
      .toString();

    this.location.go(url);
  }

  generateReportByCriteria(criteria, isBestPerformingInfluencerSorting?) {
    this.moduleArr = [];
    // update link
    this.updateSupportLink(this.reportCriteria);

    // cancel all pending request
    this.cancelPendingRequest();

    if (!isBestPerformingInfluencerSorting) {
      // clear the previous data
      this.resetReportData();
    }

    // check the validation of criteria
    if (!this.isValidCriteriaToGenerateReport(criteria)) {
      // criteria invalid because report is not loaded yet. Don't need to report Sentry
      if (!this.selectedReport) {
        return;
      }
      this.showWarningNotification();
      // Report to Sentry
      Sentry.captureException(new Error(this.notificationContent));
      // stop generating if the no filter or no selected report
      return;
    }
    // fulfill the missing criteria
    const fulfillCriteria = this.fulfillCriteria(criteria);

    // perform report generation for each section
    this.selectedReport.sectionList.forEach((section: ReportSection) => {
      this.generateReportBySection(section.id, fulfillCriteria);
    });
  }

  closeModal() {
    this.modalService.close();
  }

  private showWarningNotification() {
    this.notificationContent = this.translate.instant('measure.notification');
    this.modalService.open(this.notificationMeasure, undefined, true);
  }

  exitWithoutChanging() {
    const originalModuleIds = this.selectedReport.sectionList.map(s => s.id);
    this.moduleDropDown.availableModuleList = this.moduleList.filter(am => originalModuleIds.indexOf(am.id) >= 0)
      .map(m => Object.assign({}, m, {
        isActive: true
      }));
    this.moduleDropDown.selectedGroupId = CommonConstant.ALL_MODULES_ID;
    this.closeModal();
    this.editingReportMode = false;
  }

  exitEditReport() {
    this.closeModal();
    this.editingReportMode = false;
    this.moduleDropDown.selectedGroupId = CommonConstant.ALL_MODULES_ID;
    this.companyChangeCallback(this.userService.getCompanyId());
  }

  onCloseBottomBar(data) {
    if (data.isReloadList) {
      this.userService.getAllProjectOfAdvertiser().subscribe((res: any) => {
        this.listProjectOfAdvertiser = [{
          id: 0,
          name: this.translate.instant('measure.create_new_project')
        }];

        this.listProjectOfAdvertiser.push(...res.data);
        if (data.isCreatedNew) {
          // set the new project to be default
          this.reportCriteria.project_id = data.projectId;
          this.generateReportByCriteria(this.reportCriteria);
        }
      });
    } else if (this.selectedProject.id === 0) {
      // in case create new project, when canceling new project, should set the first project as default
      if (this.listProjectOfAdvertiser.length > 1) {
        this.reportCriteria.project_id = this.listProjectOfAdvertiser[1].id;
        // generate the default report by the default project id
        this.generateReportByCriteria(this.reportCriteria);
      }
    }
    this.statusBottomBar = 'inactive';
  }

  fulfillCriteria(rawCriteria: MeasureSearchCriteria): MeasureSearchCriteria {
    const criteria = new MeasureSearchCriteria();
    criteria.company_id = this.userService.getCompanyId();
    criteria.channel = rawCriteria.channel || 0;
    criteria.blog_id = rawCriteria.blog_id || 0;
    criteria.influencerGroup = rawCriteria.influencerGroup || 0;
    if (rawCriteria.project_id > 0) {
      criteria.project_id = rawCriteria.project_id;
    } else if (rawCriteria.campaign_id > 0) {
      criteria.project_id = rawCriteria.campaign_id;
    } else {
      criteria.project_id = 0;
    }
    criteria.date = rawCriteria.date || CommonConstant.DAYS_OF_WEEK;
    criteria.mention = rawCriteria.mention || 0;
    criteria.page_no = rawCriteria.page_no || CommonConstant.START_PAGE_INDEX;
    criteria.country_id = rawCriteria.country_id || 0;
    criteria.period = rawCriteria.period;
    criteria.orderBy = rawCriteria.orderBy;
    return criteria;
  }

  buildPeriodInfo() {
    if (!this.reportCriteria || !this.reportCriteria.period) {
      return '';
    }
    const endDate = this.reportCriteria.period.formattedEndDate;
    const startDate = this.reportCriteria.period.formattedStartDate;
    const startDateStr = DateUtils.formatDate(startDate.toString(), {day: 'numeric', month: 'short'}, CommonConstant.US_LOCALE);
    const endDateStr = DateUtils.formatDate(endDate.toString(), {day: 'numeric', month: 'short'}, CommonConstant.US_LOCALE);
    const year = endDate.getFullYear();
    return `${startDateStr} - ${endDateStr}, ${year}`;
  }

  private isValidCriteriaToGenerateReport(criteria: MeasureSearchCriteria): boolean {
    // only trigger report generation when have at least a selection
    const hasSelectedProject = (criteria.project_id !== undefined && criteria.project_id != null) ||
      (criteria.campaign_id !== undefined && criteria.campaign_id != null);

    const selectProject = this.listProjectOfAdvertiser.find(p => p.id === criteria.project_id);
    this.selectedProjectWithoutMention = selectProject && selectProject.projectKeywords.length === 0;

    const hasSelectedGroup = criteria.influencerGroup !== undefined && criteria.influencerGroup != null;
    const hasSelectedChannel = criteria.channel !== undefined && criteria.channel != null;

    return this.selectedReport !== undefined &&
           this.reportCriteria !== undefined &&
           !this.selectedProjectWithoutMention &&
           ( hasSelectedProject ||
             hasSelectedGroup ||
             hasSelectedChannel );
  }

  private generateReportBySection(section: ReportSectionEnum, criteria: MeasureSearchCriteria) {
    switch (section) {
      case ReportSectionEnum.ROI_REPORT:
        this.roiReportSubscription = this.measureService.getRoiReportData(criteria).subscribe((res) => {
          this.updateReportData(ReportSectionEnum.ROI_REPORT, res);
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.ROI_REPORT);
        });
        break;
      case ReportSectionEnum.TIMELINE_REPORT:
        this.performanceTimelineReportSubscription = this.measureService.getPerformanceTimeline(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.TIMELINE_REPORT, res, 'measure.performance_timeline');
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.TIMELINE_REPORT);
          });
        break;
      case ReportSectionEnum.KPI_REPORT:
        this.performanceGlobalKPIReportSubscription = this.measureService.getPerformanceGlobalKPIsFromEs(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.KPI_REPORT, res);
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.KPI_REPORT);
          });
        break;
      case ReportSectionEnum.LOCAL_AREAS_REPORT:
        this.marketDrillDownReportSubscription = this.measureService.getPerformanceLocalAreas(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.LOCAL_AREAS_REPORT, res);
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.LOCAL_AREAS_REPORT);
          });
        break;
      case ReportSectionEnum.MENTION_TIMELINE_REPORT:
        this.mentionTimelineReportSubscription = this.measureService.getPerformanceMentionTimeLineChart(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.MENTION_TIMELINE_REPORT, res.data.data, 'measure.mention_timeline');
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.MENTION_TIMELINE_REPORT);
          });
        break;
      case ReportSectionEnum.EXPOSURE_KPI_REPORT:
        this.exposureKPIReportSubscription = this.measureService.getExposureGlobalKPIs(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.EXPOSURE_KPI_REPORT, res);
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.EXPOSURE_KPI_REPORT);
          });
        break;
      case ReportSectionEnum.BEST_EXPOSURE_REPORT:
        this.bestPerformanceExposuresReportSubscription = this.measureService.getExposuresReport(criteria)
          .subscribe((res: any) => {
            this.updateReportData(ReportSectionEnum.BEST_EXPOSURE_REPORT, {
              topExposure: this.isValidExposureData(res.exposures) ? [
                res.exposures.reach,
                res.exposures.engagement,
                res.exposures.impact
              ] : [],
              bestPerformanceExposures: res.bestPreformingExposures.contents
            });
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.BEST_EXPOSURE_REPORT);
          });
        break;
      case ReportSectionEnum.EXPOSURE_PLATFORM_REPORT:
        this.platformReachSubscription = this.measureService.getPlatformReachReportData(criteria).subscribe((res) => {
          this.updateReportData(ReportSectionEnum.EXPOSURE_PLATFORM_REPORT, res);
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.EXPOSURE_PLATFORM_REPORT);
        });
        break;
      case ReportSectionEnum.INSIGHT_BENCHMARK_REPORT:
        this.benchmarkPerformanceReportSubscription = this.measureService.getInsightBenchmarkPerformance(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.INSIGHT_BENCHMARK_REPORT, res.benchmarkPerformance, 'measure.benchmark_performance');
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.INSIGHT_BENCHMARK_REPORT);
          });
        break;
      case ReportSectionEnum.INTERACTION_REPORT:
        this.interactionReportSubscription = this.measureService.getInfluencerPostInteractionsFromES(criteria, this.numberOfPostInInteractionPdf)
        .subscribe((res) => {
          this.updateReportData(ReportSectionEnum.INTERACTION_REPORT, res, 'measure.interactions.interactions');
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.INTERACTION_REPORT);
        });
        break;
      // TODO not implemented yet API
      case ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT:
        this.insightOpportunityReportSubscription = this.measureService.getInsightChannelOpportunity(criteria)
        .subscribe((res) => {
          this.updateReportData(ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT, res.channelOpportunity, 'measure.channel_opportunity');
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT);
        });
        break;
      case ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT:
        this.segmentInfluencerOverviewSubscription = this.measureService.getSegmentInfluencer(criteria)
          .subscribe((res) => {
            this.updateReportData(ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT, res, 'measure.influencer_overview');
          },
          (error) => {
            this.updateReadyReportModule(ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT);
          }
        );
        break;
      case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
        this.topicDrillDownReportSubscription = this.measureService.getSegmentTopics(criteria)
          .subscribe((res: any) => {
            let reportData = res;
            if (this.removedTopicInsights) {
              reportData = Object.assign({}, res, {
                removeTopics: this.removedTopicInsights
              });
            }
            this.updateReportData(ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT, reportData, 'measure.segments');
          }, (error) => {
            this.updateReadyReportModule(ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT);
          });
        break;
      case ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT:
        this.segmentIndustryReportSubscription = this.measureService.loadSegmentIndutries(criteria).subscribe((res) => {
          this.updateReportData(ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT, res);
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT);
        });
        break;
      // TODO not implemeted API yet
      case ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT:
        this.bestPerformingReportSubscription = this.measureService.getBestPerformingInfluencersFromES(criteria).subscribe((res) => {
          this.bestPerformingReportDataForReach = res.data;
          this.updateReportData(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT, this.bestPerformingReportDataForReach, 'measure.best_performing_influencers');
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT);
        });
        criteria.orderBy = BestPerformingInfluencerSortBy.ENGAGEMENT;
        this.bestPerformingReportForEngagementSubscription = this.measureService.getBestPerformingInfluencersFromES(criteria).subscribe((res) => {
          this.bestPerformingReportDataForEngagement = res.data;
        });
        break;
      case ReportSectionEnum.OONA_REPORT:
        this.oonaReportSubscription = this.measureService.loadOONAReportData(criteria,  this.numberOfPostInOnnaPdf).subscribe((res) => {
          this.updateReportData(ReportSectionEnum.OONA_REPORT, res, 'measure.oona');
        }, (error) => {
          this.updateReadyReportModule(ReportSectionEnum.OONA_REPORT);
        });
        break;
    }
  }

  private findTheMaximunPositionOfModule(report: Report): number {
    let maxPos = 1;

    if (!report) {
      return maxPos;
    }

    report.sectionList.forEach((section) => {
      if (section.position > maxPos) {
        maxPos = section.position;
      }
    });

    return maxPos + 1;
  }

  private isExistingModule(report: Report, module: ReportSection) {
    if (!report) {
      return true;
    }

    return report.sectionList.filter(section => section.id === module.id).length > 0;
  }

  private isValidExposureData(exposureData) {
    return exposureData && (exposureData.engagement.influencer_id || exposureData.reach.influencer_id || exposureData.impact.influencer_id);
  }

  /**
   * Everytime when user select an existing report. The data of previous report should be clear
   */
  private resetReportData() {
    // discard previous report data
    this.reportData = {};
  }

  /**
   * Everytime when user select an existing report or change the criteria.
   * All pending HTTP request should be canceled;
   */
  private cancelPendingRequest() {
    if (this.roiReportSubscription) {
      this.roiReportSubscription.unsubscribe();
    }
    if (this.performanceTimelineReportSubscription) {
      this.performanceTimelineReportSubscription.unsubscribe();
    }
    if (this.performanceGlobalKPIReportSubscription) {
      this.performanceGlobalKPIReportSubscription.unsubscribe();
    }
    if (this.marketDrillDownReportSubscription) {
      this.marketDrillDownReportSubscription.unsubscribe();
    }
    if (this.mentionTimelineReportSubscription) {
      this.mentionTimelineReportSubscription.unsubscribe();
    }
    if (this.exposureKPIReportSubscription) {
      this.exposureKPIReportSubscription.unsubscribe();
    }
    if (this.topExposuresReportSubscription) {
      this.topExposuresReportSubscription.unsubscribe();
    }
    if (this.bestPerformanceExposuresReportSubscription) {
      this.bestPerformanceExposuresReportSubscription.unsubscribe();
    }
    if (this.benchmarkPerformanceReportSubscription) {
      this.benchmarkPerformanceReportSubscription.unsubscribe();
    }
    if (this.interactionReportSubscription) {
      this.interactionReportSubscription.unsubscribe();
    }
    if (this.insightOpportunityReportSubscription) {
      this.insightOpportunityReportSubscription.unsubscribe();
    }
    if (this.segmentIndustryReportSubscription) {
      this.segmentIndustryReportSubscription.unsubscribe();
    }

    if (this.segmentInfluencerOverviewSubscription) {
      this.segmentInfluencerOverviewSubscription.unsubscribe();
    }
    if (this.platformReachSubscription) {
      this.platformReachSubscription.unsubscribe();
    }
    if (this.bestPerformingReportSubscription) {
      this.bestPerformingReportSubscription.unsubscribe();
    }
    if (this.bestPerformingReportForEngagementSubscription) {
      this.bestPerformingReportForEngagementSubscription.unsubscribe();
    }
  }

  private buildReportList(existsingReports: Report[], selectedReportId?: number, reloadContent?: boolean): Report[] {
    const listExistingReport: Report[] = [];
    // reset selected report
    this.selectedReport = undefined;

    // if default report is not null and belonged to current account, then choose it as default
    if (selectedReportId !== undefined) {
      this.selectedReport = existsingReports.find((report) => report.id === selectedReportId);
      this.updateSupportLink(this.reportCriteria);
    }

    // if no default or default is not belonged to current account, choose the first one in list
    if (!this.selectedReport) {
      // reset the default report
      this.initializeCriteria.reportId = null;
      if (existsingReports[0]) {
        this.selectedReport = existsingReports[0];
      } else {
        this.selectedReport = new Report();
      }
    }

    // retrieved list selected module Ids
    if (this.selectedReport) {
      this.selectedModuleIds = this.selectedReport.sectionList.map(section => section.id);
      this.buildListModuleForPdf();
    }

    // track event with Segment
    if (this.listProjectOfAdvertiser.length > 1 && this.selectedReport && this.selectedReport.id > 0) {
      this.viewReportTracker(this.selectedReport, this.listProjectOfAdvertiser[1]);
    }

    if (reloadContent && (!this.userService.isFreeUser() || this.userService.isAdmin)) {
      // rebuild report content
      this.generateReportByCriteria(this.reportCriteria);
    }

    listExistingReport.push(...existsingReports);
    return listExistingReport;
  }

  private buildListModuleForPdf() {
    this.listModuleForPdf = ObjectUtils.deepClone(this.selectedModuleIds);
    this.selectedModuleIds.forEach(sm => {
      if (sm === ReportSectionEnum.ROI_REPORT && this.numberOfPostInRoiPdf) {
        const roiPdfPages = this.calculatePageForPdf(this.numberOfPostInRoiPdf, ReportSectionEnum.ROI_REPORT);
        this.duplicateModulePdf(roiPdfPages, ReportSectionEnum.ROI_REPORT);
      }
      if (sm === ReportSectionEnum.OONA_REPORT && this.numberOfPostInOnnaPdf) {
        const oonaPdfPages = this.calculatePageForPdf(this.numberOfPostInOnnaPdf, ReportSectionEnum.OONA_REPORT);
        this.duplicateModulePdf(oonaPdfPages, ReportSectionEnum.OONA_REPORT);
      }
      if (sm === ReportSectionEnum.INTERACTION_REPORT && this.numberOfPostInInteractionPdf) {
        const interactionPdfPages = this.calculatePageForPdf(this.numberOfPostInInteractionPdf, ReportSectionEnum.INTERACTION_REPORT);
        this.duplicateModulePdf(interactionPdfPages, ReportSectionEnum.INTERACTION_REPORT);
      }
    });
  }

  private duplicateModulePdf(numOfPage, moduleId) {
    const moduleIndex = this.listModuleForPdf.findIndex(sm => sm === moduleId);
    if (moduleIndex >= 0) {
      for (let i = 1; i < numOfPage; i++) {
        this.listModuleForPdf.splice(moduleIndex + i, 0, moduleId);
        this.updateComponentIndexMapping(moduleId, moduleIndex + i, i);
      }
    }
  }

  private updateComponentIndexMapping(reportType, originalIndex, componentIndex) {
    switch (reportType) {
      case ReportSectionEnum.ROI_REPORT:
        this.roiIndexMapping.set(originalIndex, componentIndex);
        break;
      case ReportSectionEnum.OONA_REPORT:
        this.oonaIndexMapping.set(originalIndex, componentIndex);
        break;
      case ReportSectionEnum.INTERACTION_REPORT:
        this.interactionIndexMapping.set(originalIndex, componentIndex);
        break;
    }
  }

  private updateReportData(section: ReportSectionEnum, data: any, titleKey?: string) {
    Object.defineProperty(this.reportData, section, {
      value: {
        title: titleKey ? this.translate.instant(titleKey) : undefined,
        data: data
      },
      writable: false
    });
    this.updateReadyReportModule(section);
  }

  private updateReadyReportModule(section: ReportSectionEnum) {
    if (this.moduleArr.indexOf(section) < 0) {
      this.moduleArr.push(section);
    }
  }

  private getDefaultDateRange(): DateRange {
    const today = DateUtils.now();
    const toDate = NgbDateUtils.convertNgbDate(today);
    const daysBackward = DateUtils.addPerid(today, -MeasureReportTimeline.A_MONTH);
    const fromDate = NgbDateUtils.convertNgbDate(daysBackward);
    return DateRange.buildDateRangeWithBorder(fromDate, toDate);
  }

  public onFilterShowChange(isFilterShow) {
    this.isFilterShow = isFilterShow;
  }

  public onReportDataChange(data) {
    let mergedCriteria = Object.assign({}, this.reportCriteria, data.criteriaChange);
    mergedCriteria.project_id = this.reportCriteria.project_id;
    mergedCriteria = this.fulfillCriteria(mergedCriteria);
    this.generateReportBySection(data.reportSection, mergedCriteria);
  }

  public onReportSettingsChange(data) {
    switch (data.reportType) {
      case ReportSectionEnum.INSIGHT_BENCHMARK_REPORT:
        this.activeBenchmarkPerformance = data.value;
        break;
      case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
        this.removedTopicInsights = data.value;
        break;
      case ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT:
        this.activeChannelOpportunity = data.value;
        break;
    }
    this.updateSupportLink(this.reportCriteria);
  }

  public exportCsv() {
    let projectId = this.reportCriteria.project_id || 0;
    if (this.reportCriteria.campaign_id) {
      projectId = this.reportCriteria.campaign_id;
    }
    const influencerGroupId = this.reportCriteria.influencerGroup || 0;
    // stop processing if there is no project or campaign or group has been selected
    if (projectId === 0 && influencerGroupId === 0) {
      this.showWarningNotification();
      return;
    }
    // show notification
    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
    // call to server to export CSV file
    this.measureService.exportCSV(projectId, influencerGroupId,
      this.reportCriteria.period.startDate, this.reportCriteria.period.endDate).subscribe();
  }

  public exportPdfReport(evt) {
    this.numberOfPostInInteractionPdf = evt.interactionPage;
    this.numberOfPostInOnnaPdf = evt.postEngagementPage;
    this.numberOfPostInRoiPdf = evt.roiPage;
    const companyId = this.userService.getCompanyId();
    const target = this.getTrackerReportCriteriaTarget(this.reportCriteria);
    this.downloadPDF();
  }

  public downloadPDF() {
    // cancel previous request
    if (this.exportPdfSubcription) {
      this.exportPdfSubcription.unsubscribe();
    }
    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);

    const selectedProject = this.reportCriteria.project_id;
    const selectedCampaign = this.reportCriteria.campaign_id;
    const fulFillCriteria = this.fulfillCriteria(this.reportCriteria);
    let params = Object.assign({}, fulFillCriteria, {
      reportId: this.selectedReport.id,
      project_id: selectedProject || 0,
      campaign_id: selectedCampaign || 0,
      period: null,
      date: null,
      from: fulFillCriteria.period ? fulFillCriteria.period.startDate : null,
      to: fulFillCriteria.period ? fulFillCriteria.period.endDate : null,
      benchmark_posts: this.numberOfPostInOnnaPdf,
      interaction_posts: this.numberOfPostInInteractionPdf,
      roi_posts: this.numberOfPostInRoiPdf,
      removed_ti: this.removedTopicInsights ? this.removedTopicInsights.join(',') : null
    });

    if (this.activeBenchmarkPerformance) {
      params = Object.assign({}, params, {
        active_bp: this.activeBenchmarkPerformance
      });
    }

    if (this.activeChannelOpportunity) {
      params = Object.assign({}, params, {
        active_co: this.activeChannelOpportunity
      });
    }

    this.exportPdfSubcription = this.pdfViewerService.generateMeasurePdf(params, this.userService.getCompanyId())
      .subscribe((res: any) => {
        // track event by segment
        const target = this.getTrackerReportCriteriaTarget(this.reportCriteria);
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, {
          id: target.targetId,
          name: target.targetName,
          type: target.targetType
        }, {
          action: UserActionType.EXPORT,
          source: ActionSource.BOTTOM_BAR,
        }, {
          id: this.selectedReport.id,
          name: this.selectedReport.name
        }, {
          type: ActivePages.MEASURE,
          name: this.selectedReport.name,
          id: this.selectedReport.id
        }, {
          report_from: this.reportCriteria.period.startDate,
          report_to: this.reportCriteria.period.endDate
        });
      });
  }

  closeExportingPopup(evt) {
    if (this.measureExporting) {
      this.measureExporting.isSelectedPostCount = false;
    }
  }

  get logoImage() {
    return this.userService.logoImage;
  }

  public viewReportTracker(report, project) {
    if (!project || !report) {
      return;
    }
    // track report view action to Segment
    this.trackMeasureView(report, this.reportCriteria);
  }

  get activePage(): ActivePage {
    return {
      type: ActivePages.MEASURE
    };
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

  get shouldDisableFreemiumFeature() {
    return this.isFreeUser && !this.userService.isAdmin;
  }

  measureContextData(contextType) {
    if (!this.selectedReport) {
      return null;
    }
    let data = {
      action: UserActionType.ACTION,
      item: Page.REPORT,
      params: {
        action: contextType === 'create' ? UserActionType.CREATE : UserActionType.UPDATE,
        source: ActionSource.PAGE
      },
    };

    if (contextType !== 'create') {
      data = Object.assign({}, data, {
        report: {
          id: this.selectedReport.id,
          name: this.selectedReport.name
        }
      });
    }
    return data;
  }

  get canActivateModuleDropdown() {
    return this.moduleList && this.moduleList.length > 0 && this.selectedReport;
  }

  get maxPageOfPostEngagement() {
    const postEngagement = this.getReportDataById(ReportSectionEnum.OONA_REPORT);
    return postEngagement ? this.roundPageCount(postEngagement.totalCount) : null;
  }

  get maxPageOfRoi() {
    const roiData = this.getReportDataById(ReportSectionEnum.ROI_REPORT);
    return roiData ? this.roundPageCount(roiData.totalRow) : null;
  }

  get maxPageOfInteraction() {
    const interactionData = this.getReportDataById(ReportSectionEnum.INTERACTION_REPORT);
    return interactionData ? this.roundPageCount(interactionData.totalRows) : null;
  }

  public showAlertWhenModifyingDefaultReport() {
    this.modalService.open(this.notificationWarningEditDefaultReport, undefined, true);
  }

  public openExportingModulePopup() {
    if (this.moduleArr.length !== this.selectedModuleIds.length) {
      return;
    }
    const currentState = this.showExportingModule;
    if (currentState) {
      this.closeExportingModulePopup();
    } else {
      this.showExportingModule = true;
    }
  }

  public closeExportingModulePopup() {
    if (this.measureExporting) {
      this.measureExporting.isSelectedPostCount = false;
    }
    this.showExportingModule = false;
  }

  public onCLickOutsidePopup(evt) {
    if (evt.target.classList.contains('export-button')) {
      evt.preventDefault();
      return;
    }
    this.closeExportingModulePopup();
  }

  private roundPageCount(itemCount) {
    const normalizeTotalItem = Math.min(itemCount, CommonConstant.MAX_ITEM_ALLOWED_BY_PDF);
    return normalizeTotalItem;
  }

  private calculatePageForPdf(pageCount, module) {
    const normalizeTotalPage = Math.min(pageCount, CommonConstant.MAX_ITEM_ALLOWED_BY_PDF);
    let totalFullPage;
    let hasPartialPage;
    switch (module) {
      case ReportSectionEnum.ROI_REPORT:
        totalFullPage = Math.floor((normalizeTotalPage + 2) / CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE);
        hasPartialPage = ((normalizeTotalPage + 2) % CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE) > 0;
        break;
      case ReportSectionEnum.OONA_REPORT:
        totalFullPage = Math.floor(normalizeTotalPage / CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE);
        hasPartialPage = (normalizeTotalPage % CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE) > 0;
        break;
      case ReportSectionEnum.INTERACTION_REPORT:
        totalFullPage = Math.floor((normalizeTotalPage + 2) / CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE);
        hasPartialPage = ((normalizeTotalPage + 2) % CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE) > 0;
        break;
    }
    return hasPartialPage ? totalFullPage + 1 : totalFullPage;
  }

  onSelectBestPerformingInfluencerSorting(evt) {
    this.reportCriteria.orderBy = evt;
    this.selectedBestPerformingInfluencerOrder = evt;
    // update link
    this.updateSupportLink(this.reportCriteria);

    // cancel all pending request
    this.cancelPendingRequest();

    // check the validation of criteria
    if (!this.isValidCriteriaToGenerateReport(this.reportCriteria)) {
      // criteria invalid because report is not loaded yet. Don't need to report Sentry
      if (!this.selectedReport) {
        return;
      }
      this.showWarningNotification();
      // Report to Sentry
      Sentry.captureException(new Error(this.notificationContent));
      // stop generating if the no filter or no selected report
      return;
    }
    if (evt === BestPerformingInfluencerSortBy.REACH) {
      this.updateReportData(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT, this.bestPerformingReportDataForReach, 'measure.best_performing_influencers');
    } else {
      this.updateReportData(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT, this.bestPerformingReportDataForEngagement, 'measure.best_performing_influencers');
    }
  }

  get disableExportButton() {
    return this.moduleArr.length !== this.selectedModuleIds.length;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure.component.ts